module.exports = __webpack_public_path__ + "img/rep.3e589056.svg";